<template>
  <b-dropdown
    variant="flat"
    size="sm"
    class="dropdown-tag"
    :disabled="disabled"
  >
    <template #button-content>
      <i class="fas fa-plus" /> {{ legenda }}
    </template>
    <b-dropdown-item-btn
      v-for="(item, $index) in tags"
      :key="$index"
      @click="addTag(tags[$index])"
    >
      <i class="fas fa-plus" /> {{ item }}
    </b-dropdown-item-btn>
  </b-dropdown>
</template>

<style lang="scss">
.dropdown-tag {
  padding-top: 0.2rem;
  padding-bottom: 0.2rem;
}

.dropdown-tag .dropdown-item:hover {
  color: var(--primary);
}

@media(max-height: 700px){
.dropdown-tag ul{
  overflow: auto;
  max-height: 405px;

    &::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: #f5f5f5;
  }

  &::-webkit-scrollbar {
    width: 10px;
    background-color: #f5f5f5;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #dbdbdb;
  }
}
}

.dropdown-tag .btn{
  color: var(--primary);
}

.dropdown-tag .dropdown-item {
  color: var(--primary);
}
</style>

<script>
export default {
  name: 'DropdownTag',
  props: {
    tags: {
      type: [Array],
      default: () => [],
    },
    valueText: {
      type: String,
      default: () => null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    grupoTags: {
      type: String,
      default: () => null,
    },
    legenda: {
      type: String,
      default: () => 'Adicionar tag',
    },
  },
  data() {
    return {
      valueAttr: '',
    }
  },
  computed: {
    text: {
      get() {
        return this.valueAttr ? this.valueAttr : this.valueText
      },
      set(newValue) {
        this.valueAttr = newValue
        return this.valueAttr
      },
    },
  },
  watch: {
    valueText(val, oldVal) {
      if (val !== oldVal) {
        this.valueAttr = val
      }
    },
  },
  methods: {
    addTag(tag) {
      const mergeFieldText = this.grupoTags === null ? `{${tag}}` : `{${this.grupoTags} ${tag}}`
      this.$emit('enviar-pai', mergeFieldText)
    },
  },
}
</script>
